import { render } from "./AdminSkillGroups.vue?vue&type=template&id=8ee96ad2"
import script from "./AdminSkillGroups.vue?vue&type=script&lang=js"
export * from "./AdminSkillGroups.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Gelo\\Desktop\\Firebase Project\\eporrtfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__